import React, { useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faKey, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import useFetch from '../../../hooks/useFetch';
import Swal from "sweetalert2";
import { AuthContext } from "../../../contexts/AuthContext";
// https://dev.to/bytebodger/constructors-in-functional-components-with-hooks-280m
// https://reactjs.org/docs/hooks-state.html
// https://beta.reactjs.org/reference/react/useRef
// https://ui.dev/react-router-pass-props-to-link

export default function Senha() {
    const navigate = useNavigate();
    const { put } = useFetch();
    const { user } = useContext(AuthContext);
    const defaultState = {
        acao: "Criar",
        usuario: { id_usuario: "", email: "", senha_nova: "", confirma_senha:""}
    }

    /* objeto recebido do state={} do <Link> da página anterior
    ** https://v5.reactrouter.com/web/api/location  https://v5.reactrouter.com/web/api/Hooks/uselocation */
    let location = useLocation();

    const [state, setState] = useState(() => {
        // se a página anterior passou um state, retorna ele
        if (location.state) {
            if (location.state.acao) {
                defaultState.acao = location.state.acao;
            }
        }
        // senão, retorna um objeto vazio
        return defaultState;
    });

    /* https://reactjs.org/docs/hooks-reference.html#functional-updates
    ** handleChange: quando um campo do formulário é alterado, atualiza o objeto state */
    function changeUsuario(event) {
        let name = event.target.name; // name do campo que disparou o evento
        let value = event.target.value; // value do campo    

        // ex: se o campo com name Nome for alterado, atualiza o objeto state com o novo valor do campo Nome
        // { Nome: "novo valor do campo Nome" }
        setState(prevState => ({
            ...prevState,
            usuario: {
                ...prevState.usuario,
                [name]: value
            }
        }));
    }

    async function salvarUsuario() {
        if (state.usuario.senha_nova.length < 6) {
            Swal.fire({ title: "Senha muito curta", text: "Use pelo menos 6 caracteres.", icon: "warning" });
            return;
        }
        if (state.usuario.senha_nova !== state.usuario.confirma_senha) {
            Swal.fire({ title: "Senhas não coincidem", text: "As duas senhas informadas precisam ser iguais.", icon: "warning" });
            return;
        }

        try {
            // O backend identifica QUEM está trocando a senha pelo token de
            // autenticação (req.id_usuario, validado no middleware authorize),
            // não pelo id que o cliente manda — por isso não precisa (e não
            // deve) enviar o objeto `user` inteiro aqui.
            const body = { senha_nova: state.usuario.senha_nova };
            let response = await put("/alterarsenha", body);
            if (response.status === 200) {
                Swal.fire({ title: "Senha alterada com sucesso!", icon: "success" });
                const url = "/admin/usuarios/" + user?.id_usuario;
                navigate(url, { state: { acao: "Editar" } });
            } else {
                Swal.fire({
                    title: "Não foi possível alterar a senha",
                    text: response.result?.message ?? "Erro ao alterar senha",
                    icon: "error",
                })
            }
        } catch (error) {
            console.error("Erro no salvarUsuario():", error);
            Swal.fire({ title: "Erro inesperado ao alterar a senha", icon: "error" });
        }
    }

    return (
        <div className="admin-page-container">
            {/* Link de Retorno Moderno */}
            <div className="mb-4">
                <Link 
                    to={"/admin/usuarios/" + user?.id_usuario} 
                    state={{ acao: "Editar" }} 
                    className="btn-back-modern"
                >
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> 
                    Voltar ao perfil
                </Link>
            </div>

            <Card className="filter-card-admin" style={{ maxWidth: '600px', margin: '0 auto' }}>
                <Card.Body className="p-4">
                    {/* Título com Accent Visual */}
                    <div className="section-title-modern mb-4">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">Segurança da Conta</h2>
                            <p className="admin-subtitle small mb-0 text-muted">Defina uma nova senha forte para o seu acesso</p>
                        </div>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-12">
                                <Form.Label className="label-admin">
                                    <FontAwesomeIcon icon={faKey} className="me-2 text-muted" />
                                    Nova Senha
                                </Form.Label>
                                <Form.Control
                                    type="password"
                                    className="input-moderno"
                                    name="senha_nova"
                                    placeholder="Mínimo 6 caracteres"
                                    value={state.usuario.senha_nova}
                                    onChange={changeUsuario}
                                />
                            </Form.Group>

                            <Form.Group className="col-12">
                                <Form.Label className="label-admin">
                                    <FontAwesomeIcon icon={faShieldAlt} className="me-2 text-muted" />
                                    Confirme a Nova Senha
                                </Form.Label>
                                <Form.Control
                                    type="password"
                                    className="input-moderno"
                                    name="confirma_senha"
                                    placeholder="Repita a nova senha"
                                    value={state.usuario.confirma_senha}
                                    onChange={changeUsuario}
                                />
                            </Form.Group>
                        </div>

                        {/* Botão de Ação Centralizado */}
                        <div className="d-grid mt-5 pt-3 border-top">
                            <Button 
                                className="btn-apply-filters py-2" 
                                onClick={salvarUsuario}
                            >
                                Atualizar Senha agora
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}